import html2PDF from "jspdf-html2canvas";

export const getActiveRole = (roles) => {
    if (roles?.length) {
        if (roles.includes(ROLES.SPR_AdminUser)) {
            return ROLES.SPR_AdminUser
        } else if (roles.includes(ROLES.SPR_CS_SuperUser)) {
            return ROLES.SPR_CS_SuperUser
        }
        else if (roles.includes(ROLES.SPR_CS_Agent)) {
            return ROLES.SPR_CS_Agent
        }
        else if (roles.includes(ROLES.SPR_BusinessUser)) {
            return ROLES.SPR_BusinessUser
        }
        else if (roles.includes(ROLES.SPR_SalesAndMarketingUser)) {
            return ROLES.SPR_SalesAndMarketingUser
        }
        return ''
    }
}

export const getShortenedFileName = (str, stringLength = 40) => {
    if (str?.length > stringLength) {
        return str.substr(0, stringLength) + "...";
    }
    return str || "";
};

export const removeHash = (event) => {
    event.preventDefault();
}

export const welcomeText = () => {
    var today = new Date();
    var curHr = today.getHours();

    if (curHr < 12) {
        return 'Good Morning'
    } else if (curHr >= 12 && curHr < 16) {
        return 'Good afternoon'
    } else {
        return 'Good Evening'
    }
}

export const withoutTime = (date) => {
    if (!date) return date
    const wDate = new Date(date);
    wDate.setHours(0, 0, 0, 0);
    return wDate
}

export const isDate = function (date) {
    return (new Date(date) !== "Invalid Date") && !isNaN(new Date(date));
}

export const addFutureDateByMonth = (date, futureMonthCount = 3) => {
    if (!date) return new Date()
    let d = new Date(date)
    d.setMonth(d.getMonth() + futureMonthCount)
    return d
}

export const convertDate = (date) => {
    if (!date) return null
    date = new Date(date)
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();

    var mmChars = mm.split('');
    var ddChars = dd.split('');

    return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
}

export const convertLocalDateString = (date) => {
    if (!date) return null
    return new Date(date)?.toLocaleDateString('en-US', { timeZone: 'UTC' }) || ''
}

export const scrollToElement = (elementId) => {
    if (elementId?.length) {
        document.getElementById(elementId)?.scrollIntoView({ behavior: 'smooth' });
        return
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
}

export const downloadAsPdf = (elementId) => {
    const element = document.getElementById(elementId);
    html2PDF(element, {
        jsPDF: {
            format: 'a4',
        },
        imageType: 'image/jpeg',
        output: 'chartData.pdf'
    });
}

export const getDateWithTime = (date) => {
    if (!date) return ''
    date = new Date(date)
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let time = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + time;
    return (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
}

export const isEmptyObj = (obj) => {
    if (!obj) {
        return true;
    }

    if (typeof obj !== 'object') {
        return false;
    }

    return Object?.keys(obj).length === 0;
}

export const fileSizeRestriction = (file, type = 'pop') => {
    const fileSize = Math.round((file?.size / (1024 * 1024)))
    if (type === 'pop') {
        return fileSize >= 10 //10MB pop upload limit
    }
    return fileSize >= 1 //1MB CSV upload limit
}

export const checkFileType = (file) => {
    return ["image/gif", "image/jpg", "image/jpeg", "image/png", "application/pdf"].includes(file?.type);
}

export const ROLES = {
    SPR_AdminUser: 'SPR_AdminUser',
    SPR_CS_SuperUser: 'SPR_CS_SuperUser',
    SPR_CS_Agent: 'SPR_CS_Agent',
    SPR_BusinessUser: 'SPR_BusinessUser',
    SPR_SalesAndMarketingUser: 'SPR_SalesAndMarketingUser',
}

export const FEATURES = {
    VIEW_REGISTRATIONS_DETAILS: 'VIEW_REGISTRATIONS_DETAILS',
    EDIT_REGISTRATIONS: 'EDIT_REGISTRATIONS',
    DELETE_REGISTRATION: 'DELETE_REGISTRATION',
    MANUAL_EXTERNAL_SYNC: 'MANUAL_EXTERNAL_SYNC',
    DOWNLOAD_REGISTRATIONS_CSV: 'DOWNLOAD_REGISTRATIONS_CSV',
    UPLOAD_POP: 'UPLOAD_POP',
    UPDATE_POP: 'UPDATE_POP',
    DELETE_POP: 'DELETE_POP',
    VIEW_ENTITLEMENTS: 'VIEW_ENTITLEMENTS',
    VIEW_REPORTS: 'VIEW_REPORTS',
    DOWNLOAD_REPORT_CSV: 'DOWNLOAD_REPORT_CSV',
    VIEW_USER_INFO: 'VIEW_USER_INFO',
    VIEW_CCPA_DETAILS: 'VIEW_CCPA_DETAILS',
    DELETE_USER_INFO: 'DELETE_USER_INFO',
    VIEW_CAMPAIGN_DETAILS: 'VIEW_CAMPAIGN_DETAILS',
    EDIT_CAMPAIGN_DETAILS: 'EDIT_CAMPAIGN_DETAILS',
    VIEW_TRANSFER_ACCOUNT: 'VIEW_TRANSFER_ACCOUNT',
    TRANSFER_ACCOUNT: 'TRANSFER_ACCOUNT',
    VIEW_PROTECTION_PLAN_INFO: 'VIEW_PROTECTION_PLAN_INFO',
    UPLOAD_PROTECTION_PLAN_INFO: 'UPLOAD_PROTECTION_PLAN_INFO',
    MANAGE_RETAILER_DETAILS: 'MANAGE_RETAILER_DETAILS',
}

//file no 2 to track feature
export const accessibility = (feature, role) => {
    const ACTION_FEATURES = {
        VIEW_REGISTRATIONS_DETAILS: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: true,
            SPR_BusinessUser: true,
            SPR_SalesAndMarketingUser: false,
        },
        EDIT_REGISTRATIONS: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        DOWNLOAD_REGISTRATIONS_CSV: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: true,
            SPR_SalesAndMarketingUser: false,
        },
        DELETE_REGISTRATION: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        UPLOAD_POP: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        UPDATE_POP: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        DELETE_POP: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        VIEW_ENTITLEMENTS: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        VIEW_REPORTS: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: true,
            SPR_SalesAndMarketingUser: false,
        },
        DOWNLOAD_REPORT_CSV: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: true,
            SPR_SalesAndMarketingUser: true,
        },
        VIEW_USER_INFO: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        VIEW_CCPA_DETAILS: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: false,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        DELETE_USER_INFO: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: false,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        VIEW_CAMPAIGN_DETAILS: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: true,
            SPR_SalesAndMarketingUser: false,
        },
        EDIT_CAMPAIGN_DETAILS: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: false,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        VIEW_TRANSFER_ACCOUNT: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        TRANSFER_ACCOUNT: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        VIEW_PROTECTION_PLAN_INFO: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: true,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        UPLOAD_PROTECTION_PLAN_INFO: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        MANUAL_EXTERNAL_SYNC: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: true,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
        MANAGE_RETAILER_DETAILS: {
            SPR_AdminUser: true,
            SPR_CS_SuperUser: false,
            SPR_CS_Agent: false,
            SPR_BusinessUser: false,
            SPR_SalesAndMarketingUser: false,
        },
    }

    return Boolean(ACTION_FEATURES[feature][role]) || false
}

export const isLocalHost = window?.location?.hostname === 'localhost'